export const FIELDS = 'items(id,name),cursor,more';
export const MAX_RESULTS = 30;
